import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import DeliveryOptionsTableContainer from '../../../modules/deliveryOptions/components/DeliveryOptionsTableContainer';

const DeliveryOptions = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/delivery-options',
    withBreadcrumb: true,
    breadcrumbTitle: t('links.delivery_options'),
    withPagination: true,
    queryKey: 'delivery-options'
  });

  const tableHeaders = [{ label: t('id') }, { label: t('name') }, { label: t('active') }, { label: t('actions'), customClass: 'actions_col' }];

  if (apiDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="delivery-options-page-container">
      <ListHeader>
        <div className="filter_container"></div>
        <Button text={t('create_delivery_option')} link="/delivery-options/create-delivery-option" />
      </ListHeader>
      <DeliveryOptionsTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_delivery_options_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default DeliveryOptions;
